import { createContext } from "react";

const SesContext = createContext({User: "", Grp: ""});

export default SesContext;